// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Autocomplete from 'react-google-autocomplete';
import CustomAutoComplete from '../../utils/FormWidgets/CustomAutoComplete';
import DatePicker from '../../utils/FormWidgets/DatePicker';
import TimePicker from '../../utils/FormWidgets/TimePicker';
import Rq from '../../utils/FormWidgets/RequireField';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  getTimeWithOffset,
  getLocationDescription,
  sortArray,
} from '../../../infrastructure/utils/common';

import { setTopPosition } from '../../utils/Styles/SetTopPosition';

export default class LocalEventForm extends React.Component {
  instanceName = React.createRef();
  instanceAdress = React.createRef();

  componentDidUpdate() {
    if (!this.instanceName.current || !this.instanceAdress.current) {
      return;
    }

    this.onFocus();
  }

  onFocus = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instanceName.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instanceName);
    });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instanceAdress.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instanceAdress);
    });
  };

  handleActivityChange = val => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    handleLocalDataChange({
      ...event,
      activityId: val,
    });
  };

  handleTitleChange = ({ target }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    handleLocalDataChange({
      ...event,
      eventTitle: target.value,
    });
  };

  handleNameChange = ({ target }) => {
    setTopPosition('.pac-container', this.instanceName);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    handleLocalDataChange({
      ...event,
      eventName: target.value,
    });
  };

  locationChanged = ({ target }) => {
    setTopPosition('.pac-container', this.instanceAdress);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    const newLocation = {
      address: target.value.length > 0 ? target.value : undefined,
    };
    handleLocalDataChange({
      ...event,
      eventLocation: newLocation,
      image: undefined,
    });
  };

  locationSelected = async val => {
    const location = await getLocationDescription(val, true);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    if (val.photos) {
      handleLocalDataChange({
        ...event,
        eventLocation: location,
        image: {
          url: val.photos[0].getUrl(),
        },
      });
    } else {
      handleLocalDataChange({
        ...event,
        eventLocation: location,
      });
    }
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      TBDTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleDateChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      startDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      disabledDays,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      endDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleStartTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleEndTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      placeSelected,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tz,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      isNewEvent,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      bookableActivities,
    } = this.props;

    const activitiesData = sortArray(
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      bookableActivities?.map(activity => ({
        value: activity.id,
        label: activity.title,
      })),
      'label',
      true
    );
    return (
      <Fragment>
        <FormGroup controlId='eventTitle'>
          <ControlLabel>
            Event Title
            <Rq />
          </ControlLabel>
          <FormControl
            type='text'
            onChange={this.handleTitleChange}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.eventTitle}
            placeholder='Enter Event Title'
          />
        </FormGroup>
        <FormGroup controlId='eventName'>
          <ControlLabel>Venue Name</ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instanceName} id='instanceName'>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={placeSelected}
                  onChange={this.handleNameChange}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  value={event.eventName}
                />
              }
            </div>
          }
        </FormGroup>
        <FormGroup controlId='eventLocation'>
          <ControlLabel>Address</ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instanceAdress} id='instanceAdress'>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={this.locationSelected}
                  onChange={this.locationChanged}
                  value={
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    event.eventLocation && event.eventLocation.address // TODO: Fix this the next time the file is edited.
                      ? // eslint-disable-next-line react/prop-types
                        event.eventLocation.address
                      : ''
                  }
                />
              }
            </div>
          }
        </FormGroup>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {event.activityId && !isNewEvent && activitiesData?.length && (
          <FormGroup controlId='activity'>
            <ControlLabel>Activity:</ControlLabel>
            <CustomAutoComplete
              items={activitiesData}
              onSelect={this.handleActivityChange}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              initialValue={event.activityId}
            />
          </FormGroup>
        )}
        <div
          className='day-picker-inp col-md-3 col-sm-3 col-xs-8'
          style={{ paddingLeft: '0px', marginRight: '0px' }}
        >
          <FormGroup controlId='eventDate'>
            <DatePicker
              label='Date'
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.eventDate}
              placeholder='TBD'
              handleChange={handleDateChange}
              dayPickerProps={{
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                initialMonth: getTimeWithOffset(
                  moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                ),
                modifiers: {
                  disabled: [
                    {
                      daysOfWeek: disabledDays,
                    },
                    {
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      before: getTimeWithOffset(
                        moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                      ),
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      after: getTimeWithOffset(
                        moment(endDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                      ),
                    },
                  ],
                },
              }}
            />
          </FormGroup>
        </div>
        <FormGroup
          controlId='startTime'
          className='col-md-3 col-sm-3 col-xs-8'
          style={{ paddingLeft: '0px', marginRight: '0px' }}
        >
          <ControlLabel>Start Time</ControlLabel>
          <TimePicker
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={handleStartTimeChange}
            tbd={TBDTime}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            placeholder={event.endTime === -1 ? 'TBD' : ''}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.startTime}
          />
        </FormGroup>
        <FormGroup
          controlId='endTime'
          className='col-md-3 col-sm-3 col-xs-8'
          style={{ paddingLeft: '0px', marginRight: '0px' }}
        >
          <ControlLabel>End Time</ControlLabel>
          <TimePicker
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={handleEndTimeChange}
            tbd={TBDTime}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            placeholder={event.startTime === -1 ? 'TBD' : ''}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            disabled={event.duration > 0}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.endTime}
          />
        </FormGroup>
        <div className='clearfix' />
      </Fragment>
    );
  }
}
